<template>
  <div>
    <a-form-model layout="inline" :model="searchForm">
      <a-form-model-item label="课程名称">
        <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="课程类型">
        <a-select class="serach-item" :disabled="someTraning" allowClear v-model="searchForm.courseType" placeholder="请选择">
          <a-select-option value="1">测评课程</a-select-option>
          <a-select-option value="2">训练课程</a-select-option>
          <a-select-option value="3">活动课程</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="学段">
        <a-select allowClear v-model="searchForm.period" placeholder="请选择" mode="multiple" style="min-width: 180px">
          <a-select-option :value="item" :key="item" v-for="item in $data._period">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
      </a-form-model-item>
    </a-form-model>
    <a-table
      style="min-width: 800px"
      :columns="columns"
      :scroll="{ y: 300 }"
      rowKey="id"
      :row-selection="rowSelection"
      :pagination="{...tableRelevant.tablePagination, pageSizeOptions: ['10', '20', '50', '100', '500', '1000']}"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <div slot="name" slot-scope="text">{{ text.name }}{{ text.period ? ' - ' + text.period : '' }}</div>
      <div slot="courseType" slot-scope="text">{{ $data._courseType[text.courseType] }}课程</div>
    </a-table>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  {
    title: '关联课程',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '学段',
    dataIndex: 'period',
  },
  {
    title: '课程类型',
    scopedSlots: { customRender: 'courseType' },
  },
  {
    title: '课时数',
    dataIndex: 'courseSessionCount',
  },
]
export default {
  name: 'secondStep',
  props: {
    abilityList: {
      type: Array,
      value: [],
    },
    contentData: {
      type: Array,
      value: [],
    },
    pageData: {
      type: Object,
      value: {},
    },
  },
  data() {
    return {
      seriesInfo: this.$store.getters['course/getSeriesInfo'](),
      searchForm: {
        courseName: undefined,
        courseType: undefined,
        period: undefined,
      },
      columns,
      tableRelevant: tableRelevant.call(this, this.getPageList),
      tableSelectedRowKeys: [],
      tableSelectedRows: [],
    }
  },
  computed: {
    someTraning() {
      return !this.contentData.every((e) => e.contentType != 2 && e.contentType != 5)
    },
    rowSelection() {
      return {
        selectedRowKeys: this.tableSelectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.tableSelectedRowKeys = selectedRowKeys
          this.tableSelectedRows = this.tableSelectedRows.concat(selectedRows)
          this.tableSelectedRows = this.tableSelectedRowKeys.map((m) => {
            return this.tableSelectedRows.filter((f) => f.id === m)[0] || {}
          })
        },
      }
    },
  },
  mounted() {
    const pageData = JSON.parse(JSON.stringify(this.pageData))
    this.tableSelectedRowKeys = pageData.selectedKeys
    this.tableSelectedRows = pageData.selectedRows
    this.getPageList(1)
  },
  methods: {
    getPageList(pageIndex) {
      this.searchForm.courseType = !this.contentData.every((e) => e.contentType != 2 && e.contentType != 5) ? '2' : this.searchForm.courseType
      let params = {
        courseSeriesId: this.seriesInfo.id,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }

      this.tableRelevant.tableLoading = true
      this.$http.CourseResource.courseList(params).then(({ data }) => {
        this.tableRelevant.tableDataSource = data.items
        this.tableData = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
        this.tableRelevant.tablePagination.pageSize = data.pageSize
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
  },
}
</script>

<style scoped></style>
